import { Employee } from '@app/models/employee/employee.model';
import { BadgeColumn } from '@app/modules/table/classes/badge-column.class';
import { RadioButtonFilter } from '@app/modules/table/classes/column-filters/radio-button/radio-button-filter.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { BadgeDisplay } from '@app/modules/table/interfaces/badge-display.interface';

export class KYCStatusColumn extends BadgeColumn<Employee> {
    title = 'KYC verification';
    property = 'account.personaCompletedAt';
    sortable = true;
    type: CellDisplay = CellDisplay.badge;

    constructor() {
        super();

        const options = [
            { label: 'payroll.kyc-kyb.statuses.complete', value: true },
            { label: 'payroll.kyc-kyb.statuses.not_complete', value: false },
        ];

        this.filter = new RadioButtonFilter('personaCompletedAt', options, this.title);
    }

    getBadgeDisplay(employee: Employee): BadgeDisplay {
        // Currently we only display "complete" or "not complete" based on the personaCompletedAt attribute instead of their actual persona status
        // This is because we don't currently have the infrastructure to bulk retrieve employee's persona statuses
        if (employee.account?.personaCompletedAt) {
            return {
                type: 'success',
                label: 'payroll.kyc-kyb.statuses.complete',
            };
        }

        return {
            type: 'danger',
            label: 'payroll.kyc-kyb.statuses.not_complete',
        };
    }
}
